import {styled} from "styled-components";
import {Observer} from "mobx-react";
import {UserProfileV5} from "../user/UserProfileV5";
import {baseDistance, FlexCenterStyle, TOPBAR_HEIGHT} from "../styles/styles";
import {useAppStore} from "../../../StateManager";
import {SearchFieldStyled} from "../input/search/SearchField.styled";
import {colorPalette} from "../styles/colorPalette";
import {GetOrganizationWideNavigationMenus, NavigationEnum} from "../../../Enums";
import {ProjectNameV5} from "./ProjectNameV5";
import {ViewTabsV5} from "./ViewTabsV5";
import {MainSearchV5} from "./MainSearchV5";

export const TopBarV5 = () => {
	const appState = useAppStore((state) => state.appState);

	return (
		<Observer>
			{() => {
				const isInSettingsView = [NavigationEnum.SETTINGS].includes(appState.selectedMenu);
				const isHome = !isInSettingsView && GetOrganizationWideNavigationMenus(appState.currentUIVersion).includes(appState.selectedMenu);

				return (
					<TopBarStyled
						$isHome={isHome}
						$isSettingsView={isInSettingsView}
					>
						<ProjectNameV5 />
						{!isHome && <ViewTabsV5 />}
						<TopBarActionsStyled>
							{!isInSettingsView && <MainSearchV5 />}
							<UserProfileV5 />
						</TopBarActionsStyled>
					</TopBarStyled>
				);
			}}
		</Observer>
	);
};

const TopBarStyled = styled.div<{$isHome: boolean; $isSettingsView: boolean}>`
	${FlexCenterStyle};
	justify-content: space-between;
	position: relative;
	min-height: ${TOPBAR_HEIGHT};
	background-color: ${colorPalette.white};
	border-bottom: ${(props) => (props.$isHome || props.$isSettingsView ? `1px solid ${colorPalette.gray.c300}` : "none")};
	padding: 0 ${baseDistance.md} 0 0;
	z-index: 9;
	background-color: ${(props) => (props.$isHome || props.$isSettingsView ? colorPalette.white : colorPalette.blueGray.c100)};
	overflow: hidden;
`;

const TopBarActionsStyled = styled.div`
	${FlexCenterStyle};
	gap: ${baseDistance.md};
	flex-shrink: 0;

	&:only-of-type {
		margin-left: auto;
	}

	${SearchFieldStyled} {
		width: 200px;
		min-width: 253px;
	}
`;
